import React from 'react';
var Colon = function (_a) {
    var index = _a.index, data = _a.data;
    return index !== data.length - 1 ? (React.createElement("strong", { className: "react-countdown-simple__colon" }, ":")) : null;
};
export default Colon;
